/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FormatType {
    PRECUT = 'PRECUT',
    PREASSEMBLED = 'PREASSEMBLED',
    INSTALLED = 'INSTALLED',
}